<template>
  <div>
    <div
      v-if="!loading"
      class="row paddingt mx-auto pb-5"
      style="max-width: 1200px"
    >
      <div class="modal-fade" v-if="showModal && selected_resource">
        <div class="sub-menu-overlay" @click="close()"></div>
        <div class="video">
          <vimeo-player
            ref="player"
            @ready="onReady"
            :video-id="selected_resource.id_video"
          ></vimeo-player>
          <sync-loader
            v-if="!playerReady"
            style="
            position: absolute;
            left: 50%;
            transform: translate(-50%, -50%);
            top: 50%;
          "
            :color="color"
          ></sync-loader>
        </div>
      </div>
      <!--course details-->
      <section class="col-12 col-lg-8">
        <h1 class="has-background-primary">
          {{ selected_course.courses.name }}
        </h1>
        <div
          @click="$router.go(-1)"
          class="blue-font cursor-pointer my-3 d-flex align-items-center"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            style="max-width:17px"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M7 16l-4-4m0 0l4-4m-4 4h18"
            />
          </svg>
          <span class="ml-2">volver</span>
        </div>

        <p class="name d-lg-none" style="font-size: 17px">
          {{ selected_course.course_owner.name }}
          {{ selected_course.course_owner.lastname }} <br />
          <span class="title2">
            {{ selected_course.course_owner.specialty }}
          </span>
        </p>

        <p class="title2 d-none d-lg-block" style="margin-bottom: 50px">
          {{ selected_course.course_owner.name }}
          {{ selected_course.course_owner.lastname }} /
          <span style="font-size: 13px">
            {{ selected_course.course_owner.specialty }}
          </span>
        </p>

        <p class="text2 d-lg-none">
          {{ moment(selected_course.date_in).format("L") }}
        </p>

        <div class="d-none d-lg-inline-block">
          <p class="title2 d-inline-block mr-2">Publicado</p>
          <p class="text2 d-inline-block">
            {{ moment(selected_course.date_in).format("DD/MM/YYYY") }}
          </p>
        </div>

        <div class="tabs d-none d-lg-flex row my-4">
          <p
            class="text3"
            style="cursor: pointer; width: fit-content; padding-right: 15px"
            @click="toggleTab = 0"
          >
            Presentación
            <span class="active" v-if="toggleTab == 0"></span>
          </p>
          <p
            class="text3"
            style="cursor: pointer; width: fit-content; padding: 0 30px"
            @click="toggleTab = 1"
          >
            Modulo
            <span class="active" v-if="toggleTab == 1"></span>
          </p>
          <p
            class="text3"
            style="cursor: pointer; width: fit-content; padding: 0 30px"
            @click="toggleTab = 2"
          >
            Especialista
            <span class="active" v-if="toggleTab == 2"></span>
          </p>
          <p
            class="text3"
            style="cursor: pointer; width: fit-content; padding: 0 30px"
          >
            <!-- Comentarios -->
            <!-- @click="toggleTab = 3" -->

            <!-- <span class="active" v-if="toggleTab == 3"></span> -->
          </p>
        </div>

        <div
          class="d-lg-none mt-lg-5"
          :class="{ 'd-lg-block': toggleTab == 0 }"
        >
          <p class="title-about ext-3xl mb-6">Acerca del curso</p>
          <p
            class="font-normal  text-skin-description"
            v-html="selected_course.courses.description"
          ></p>
        </div>

        <button
          class="seeMore d-block d-lg-none"
          style="margin: 0 auto"
          @click="seeMore1 = !seeMore1"
        >
          <i class="fas fa-minus" v-if="seeMore1 != false"></i>
          <i class="fas fa-plus" v-if="seeMore1 == false"></i>
        </button>

        <div class="separator d-lg-none"></div>
      </section>

      <!--buy course-->
      <section class="col-12 col-lg-4 fix-buy-course">
        <div class="text-center">
          <div class="price d-inline-block">
            $ {{ selected_course.data.price ? selected_course.data.price : 0 }}
            <span> USD</span>
          </div>
        </div>

        <button
          @click="shopLogged"
          class="btn-buy orangeH d-block my-lg-2 mx-auto"
        >
          <span
            v-text="
              selected_course.data.free == '0' ? 'Comprar' : 'Registrarse'
            "
          />
        </button>

        <section
          class="border border-skin-secondary py-2 rounded-md mt-4 max-w-xs mx-auto flex justify-between items-center"
          v-if="showPaymentsMethods"
        >
          <button @click="buyCurse(selected_course)">
            <img src="/image/resource/paymentez.png" width="120" />
          </button>

          <div class="border border-skin-secondary h-11" />

          <button
            @click="goToHotmart(selected_course)"
            v-if="selected_course.course_hotmart"
          >
            <img src="/image/resource/logoHotmart.png" width="120" />
          </button>
        </section>


    <div class="stats text-skin-primary mt-10" style="margin-left: 20%">
      <div class="item text-skin-primary flex font-normal">
        <img src="../../../../v2/src/assets/icono_clases.svg" class="mr-3" alt="" />
         {{ selected_course.lessons_in_course }} modulos
      </div>
      <div class="item text-skin-primary flex font-normal pt-1">
        <img src="../../../../v2/src/assets/icono_clases.svg" class="mr-3" alt="" />
        {{ selected_course.resource_in_course }}Clases
      </div>
      <div class="item text-skin-primary flex font-normal pt-1">
        <img src="../../../../v2/src/assets/usuario.svg" class="mr-4" alt="" />
        {{ selected_course.users_in_course }} Alumnos
      </div>
      <div class="item text-skin-primary flex font-normal pt-1">
        <img src="../../../../v2/src/assets/icono_audio.svg" class="mr-3" alt="" />
        Audio: Español
      </div>
      <div class="item text-skin-primary flex font-normal pt-1" v-if="selected_course.data.certificate == 1">
        <img src="../../../../v2/src/assets/icono_certificate.svg" class="mr-3" alt="" />
        Certificate al Finalizar
      </div>
    </div>
        <div class="separator d-lg-none"></div>
      </section>

      <div class="modal-fade" v-if="showModal && !selected_resource">
        <div class="sub-menu-overlay" @click="close()"></div>
        <div class="modalLogin">
          <login-modal style="z-index: 99999; margin: 0 auto"></login-modal>
        </div>
      </div>

      <!--modules-->
      <section class="col-12 col-lg-8 d-block d-lg-none">
        <div class="text1 mb-4">MODULO</div>
        <div v-for="(module, index) in selected_course.modules" :key="index">
          <div class="drop-down d-flex mb-4" @click="selected = index">
            <p>{{ module.name }}</p>
            <i
              v-if="selected != index"
              class="fas fa-chevron-down"
              style="color: #446daf; width: fit-content"
            >
            </i>

            <i
              v-if="selected == index"
              class="fas fa-chevron-up"
              style="color: #446daf"
            ></i>
          </div>

          <div
            v-if="module.lessons.length != 0"
            class=""
            :class="{ 'd-none': selected != index }"
          >
            <div
              v-for="(resource, index2) in module.lessons[0].resources"
              :key="index2"
              :class="{
                unlocked: resource.data.free == 1,
                'd-none': resource.type != 1 || resource.type != 6,
                'd-flex': resource.type == 1 || resource.type == 6,
              }"
              style="margin: 0 20px; align-items: flex-start"
              class="d-flex text2"
              @click="openModalVideo(resource)"
            >
             <span>
                <padlock-open class="pr-2" v-if="resource.data.free == 1" fill="none" stroke="#e03d79"/>
                <padlock-close class="pr-2" v-if="resource.data.free == 0" fill="none" stroke="#446daf"/>
              </span>
              <span>
                {{ resource.name }}
              </span>
            </div>
          </div>
        </div>
        <div class="separator"></div>
      </section>

      <!--modules desktop -->
      <section class="d-none d-lg-block col-lg-8" v-if="toggleTab == 1">

        <div
          class="module-desk"
          v-for="(module, index) in selected_course.modules"
          :key="index"
        >
          <div class="title2 d-inline-block" style="width: 50%; float: left">
            {{ module.name }}
          </div>

          <div
            v-if="module.lessons.length != 0"
            class="d-inline-block"
            style="width: 50%; float: left; text-align: left"
          >
            <div
              v-for="(resource, index2) in module.lessons[0].resources"
              :key="index2"
              style="margin: 10px 20px;  cursor: pointer;"
              class="text1 flex items-start pb-2"
              :class="{
                unlocked: resource.data.free == 1,
                'd-none': resource.type != 1 || resource.type != 6,
                'd-flex': resource.type == 1 || resource.type == 6,
              }"
              @click="openModalVideo(resource)"
            >
              <span>
                <padlock-open class="pr-2" v-if="resource.data.free == 1" fill="none" stroke="#e03d79"/>
                <padlock-close class="pr-2" v-if="resource.data.free == 0" fill="none" stroke="#446daf"/>
              </span>
              <span class=" text-skin-description">
                {{ resource.name }}
              </span>

            </div>
          </div>
        </div>
      </section>

      <!--biography-->
      <section
        class="col-12 col-lg-8"
        :class="{ 'd-lg-none': toggleTab != 2, 'd-block': toggleTab == 2 }"
      >
        <div class="nameB">
          <span class="til23">
            {{ selected_course.course_owner.name }}
            {{ selected_course.course_owner.lastname }} <br />
          </span>
          <span class="title2">
            {{ selected_course.course_owner.specialty }}
          </span>
        </div>

        <div
          v-if="
            this.selected_course.course_owner &&
              this.selected_course.course_owner.data
          "
          class="rrss my-4"
        >
          <a class="mr-10"
            v-if="this.selected_course.course_owner.data.facebook"
            target="_blank"
            :href="this.selected_course.course_owner.data.facebook"
          >
            <facebook/>
          </a>
          <a 
            v-if="this.selected_course.course_owner.data.instagram"
            target="_blank"
            :href="this.selected_course.course_owner.data.instagram"
          >
            <instagram/>
          </a>
          <a
            v-if="this.selected_course.course_owner.data.pinterest"
            target="_blank"
            :href="this.selected_course.course_owner.data.pinterest"
          >
            <i class="fab fa-pinterest"></i>
          </a>
        </div>

        <p
          class="font-normal  pb-10 text-skin-description "
          style="display: -webkit-box; box-orient: vertical; overflow: hidden"
          :class="{ 'height-init': seeMore == !0 }"
          v-html="selected_course.course_owner.description"
        ></p>

        <button
          class="seeMore d-block d-lg-none"
          style="margin: 0 auto"
          @click="seeMore = !seeMore"
        >
          <i class="fas fa-minus" v-if="seeMore != false"></i>
          <i class="fas fa-plus" v-if="seeMore == false"></i>
        </button>

        <div class="separator d-lg-none"></div>
      </section>

      <!--comments-->
      <section
        v-if="false"
        class="col-12 col-lg-8"
        :class="{ 'd-lg-none': toggleTab != 3, 'd-block': toggleTab == 3 }"
      >
        <div class="text1 mb-4">COMENTARIOS</div>

        <div>
          <div class="comment-head">
            <div class="profile-pic"></div>
            <p class="title2 ml-4" style="margin: 0">Bonacro/96</p>
            <div class="rate d-none d-lg-inline-block ml-4">
              <i class="fas fa-star star"></i>
              <i class="fas fa-star star"></i>
              <i class="fas fa-star star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
            </div>
          </div>

          <p class="text3">
            super interesante el curso para entrar en nel mundo de la
            ilustracion, la profesora enseña en base a las emociones y sientes
            que comprende el proceso que estas pasando, super humana y el curso
            super recomendado, lo unico que se podria mejorar es que el vollumen
            es muy bajo, se entenderia mejor con un volumen mayor
          </p>
        </div>

        <div>
          <div class="comment-head">
            <div class="profile-pic"></div>
            <p class="title2 ml-4" style="margin: 0">Bonacro/96</p>
            <div class="rate d-none d-lg-inline-block ml-4">
              <i class="fas fa-star star"></i>
              <i class="fas fa-star star"></i>
              <i class="fas fa-star star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
            </div>
          </div>

          <p class="text3">
            Muy bueno, me explicó claramente los conceptos claves para hacer
            ilustraciones completas.
          </p>
        </div>
      </section>
    </div>

    <div
      v-else
      class="row paddingt mx-auto pb-5"
      style="max-width: 1200px; height: 100vh;"
    >
      <sync-loader
        :color="color"
        style="margin-left: 45%; padding-top: 10%; padding-bottom: 5%"
      ></sync-loader>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SyncLoader from "vue-spinner/src/PulseLoader.vue";
import LoginModal from "./components/LoginModal";
import PadlockClose from "../../../../v2/src/components/icons/Padlock_close.vue"
import PadlockOpen from "../../../../v2/src/components/icons/Padlock_open.vue"
import Instagram from "../../../../v2/src/components/icons/Instagram.vue";
import Facebook from "../../../../v2/src/components/icons/Facebook.vue";

export default {
  name: "Detail",
  components: {
    SyncLoader,
    LoginModal,
    PadlockClose,
    PadlockOpen,
    Instagram,
    Facebook
  },
  data() {
    return {
      toggleTab: 0,
      seeMore: 0,
      color: "#9A32D6",
      showPaymentsMethods: false,
      seeMore1: 0,
      loading: false,
      showModal: false,
      selected_resource: "",
      selected: "",
      playerReady: false,
    };
  },
  created() {
    this.getCourseDetail();
  },
  computed: {
    ...mapGetters({
      selected_course: "course/getSelectedCourse",
      isLoggedIn: "auth/isLoggedIn",
    }),
  },
  methods: {
    onReady() {
      this.playerReady = true;
    },
    getCourseDetail() {
      this.loading = true;
      this.$store
        .dispatch("course/getCoursesDetail", {
          course_id: this.$route.query.course,
        })
        .then(() => {
          this.loading = false;
        });
    },
    buyCurse() {
      localStorage.setItem("e_x_c", JSON.stringify(this.selected_course));
      this.$store
        .dispatch("shopingCart/addCart", this.selected_course)
        .then(() => {
          if (!this.isLoggedIn) {
            this.showModal = true;
            this.selected_resource = null;
          }
        });
    },
    goToHotmart(element) {
      window.open(element.course_hotmart.checkoutUrl, "_blank");
    },
    close() {
      this.showModal = false;
    },
    shopLogged() {
      if (this.selected_course.data.free == "0") {
        this.showPaymentsMethods = !this.showPaymentsMethods;
      } else {
        this.buyCurse();
      }
    },
    showRow(index) {
      this.selected_course.modules[index].show = !this.selected_course.modules[
        index
      ].show;
    },
    openModalVideo(resource) {
      if (resource.data.free == 1) {
        if (resource.type == 1 || resource.type == 6) {
          this.selected_resource = resource.data;
          this.showModal = true;
        }
      }
    },
  },
};
</script>

<style scoped>
.rrss {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}
.video {
  max-height: 400px;
  max-width: 650px;
  left: 50%;
  transform: translateX(-50%);
  right: 0;
  position: absolute;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 99999;
}

.modalLogin {
  width: 90%;
  max-width: 440px;
  left: 50%;
  transform: translateX(-50%);
  right: 0;
  position: absolute;
  z-index: 99999;
}
a > i {
  color: #000000;
}

.modal-fade {
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  top: 0;
  left: 0;
  position: fixed;
  display: flex;
  align-items: center;
}

.sub-menu-overlay {
  top: 0px;
  position: fixed;
  left: 0px;
  width: 100vw;
  height: 100%;
  z-index: 110;
  background: #446daf 0% 0% no-repeat padding-box;
  opacity: 0.6 !important;
  z-index: 9999;
  transition: fade-in 1s;
}

.overlay {
  top: 0px;
  position: fixed;
  left: 0px;
  width: 100vw;
  height: 100%;
  z-index: 110;
  background: #446daf 0% 0% no-repeat padding-box;
  opacity: 0.6 !important;
  transition: fade-in 1s;
}

@keyframes fade-in {
  from {
    opacity: 0;
    /* transform: scaleX(0); */
  }

  to {
    opacity: 0.6;
    /* transform: scaleX(1); */
  }
}

.go-back {
  position: relative;
  color: #fff;
  cursor: pointer;
  margin: 0 auto;
  margin-bottom: 40px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(180deg, #f1946d 0%, #de337a 100%) 0% 0% no-repeat
    padding-box;
  box-shadow: 0px 5px 6px #00000029;
}

.go-back i {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.box {
  z-index: 99999;
  width: 560px;
  position: fixed;
  height: 600px;
  background: #ffffff 0% 0% no-repeat padding-box;
  -webkit-box-shadow: 0px 5px 6px #00000029;
  box-shadow: 0px 5px 6px #00000029;
  border-radius: 50px;
  top: calc((100vh - 600px) / 2);
  right: calc((100vw - 560px) / 2);
}
.title-about {
  font: normal normal medium 18px/22px Roboto;
  letter-spacing: 0px;
  opacity: 1;
  font-weight: 500;
}
.button-times {
  width: 45px;
  height: 46px;
  background: transparent linear-gradient(180deg, #f1946d 0%, #de337a 100%) 0%
    0% no-repeat padding-box;
  box-shadow: 0px 5px 6px #00000029;
  border-radius: 50px;
  margin-right: -25px;
  margin-top: -10px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
  position: absolute;
  left: 78%;
  margin-right: auto;
  margin-left: auto;
  top: 10%;
}

.fa-times {
  color: white;
  font-size: 25px;
}

section {
  /* background-color: darkolivegreen; */
  padding: 20px 25px;
  text-align: left;
  font: normal normal 900 18px/25px Roboto;
  letter-spacing: 0px;
  color: #000000;
  position: relative;
}

h1 {
  text-align: left;
  font-size: 25px;
  font-weight: 900;
  color: #000000;
  padding-top: 64px;
  /* background-color: red; */
}

button {
  outline: none !important;
}

.name {
  /* background-color: blue; */
  font-size: 16px;
  color: #161616;
  font-weight: bold;
  margin: 20px 0;
}

.title2 {
  font-size: 16px;
  font-weight: normal;
  color: #161616;
}

.text1 {
  font-size: 18px;
  color: #000000;
  width: fit-content;
  font-weight: normal;
}

.text2 {
  font-size: 13px;
  color: #848484;

  /* background-color: purple; */
}

.text3 {
  color: #707070;
  opacity: 0.6;
  font-size: 16px;
  height: fit-content;
}

@media screen and (max-width: 480px) {
  .m-h167 {
    max-height: 167px;
  }
}

.btnBestSeller {
  background-color: #fc5348;
  border-radius: 5px;
  color: #ffffff;
  font-size: 11px;
  text-transform: uppercase;
  font-weight: normal;
  width: fit-content;
  padding: 0 5px;
  display: flex;
  align-items: center;
  margin-bottom: 35px;
}

.seeMore > i {
  background: -webkit-linear-gradient(#f1946d, #de337a);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 20px;
}

.i-g {
  color: #848484;
}

.separator {
  height: 1px;
  width: 90%;
  margin: 0 auto;
  background-color: #707070;
  opacity: 0.6;
  margin-top: 15px;
}

/*BUY COURSE*/
.price {
  color: #446daf;
  font-size: 33px;
  font-weight: 900;
  width: fit-content;
  margin-right: 25px;
}

.price > span {
  font-size: 19px;
}

.discount {
  color: #fc5348;
  font-size: 14px;
}

.btn-buy {
  background: transparent linear-gradient(180deg, #f1946d 0%, #de337a 100%) 0%
    0% no-repeat padding-box;
  box-shadow: 0px 5px 6px #00000029;
  border-radius: 50px;
  opacity: 1;
  color: #ffffff;
  width: 100%;
  max-width: 273px;
  height: 44px;
  margin: 0 auto;
  font-weight: normal;
  margin-top: 20px;
  margin-bottom: 20px;
}

.til23 {
  font: normal normal normal 40px/48px Roboto;
  color: #707070;
}

@media screen and (min-width: 980px) {
  .btn-buy {
    width: 317px;
    height: 51px;
    min-width: 317px;
    max-width: 317px;
    font: normal normal normal 20px/25px Roboto;
  }

  .fix-buy-course {
    position: fixed;
    right: 0;
  }
}

@media screen and (max-width: 980px) {
  .til23 {
    font: normal normal normal 30px/37px Roboto;
  }
}

.btn-buy > i {
  margin-right: 13px;
}

.paypal {
  width: 159px;
  height: 45px;
  border: 2px solid #707070;
  border-radius: 23px;
  opacity: 1;
  background-position: center;
  background-size: 90px;
  background-repeat: no-repeat;
  margin: 0 auto;
  margin-top: 25px;
  margin-bottom: 15px;
}

.btn-card {
  border: 0.5px solid #707070;
  border-radius: 23px;
  opacity: 1;
  width: 159px;
  height: 45px;
  text-align: center;
  font-size: 14px;
  margin: 0 auto;
  font-weight: normal;
  margin-bottom: 40px;
}

.drop-down {
  height: 30px;
  font-size: 15px;
  background-color: #eeeeee;
  border-radius: 15px;
  border: 1px solid #f5f5f5;
  display: flex;
  align-items: center;
  padding: 0 20px;
}
.drop-down > p {
  margin: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.drop-down > i {
  width: fit-content;
  text-align: right;
}

.nameB {
  color: #707070;
  font-size: 30px;
  font-weight: normal;
}

.profile-pic {
  width: 44px;
  height: 44px;
  border: 1px solid #707070;
  opacity: 1;
  border-radius: 50%;
}

.comment-head {
  display: flex;
  align-items: center;
  margin: 2rem 0;
}

.unlocked i {
  background: -webkit-linear-gradient(#f1946d, #de337a);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.unlocked p {
  color: #446daf;
}

.active {
  width: 100%;
  border-bottom: #000000 solid 3px;
  border-radius: 20px;
  background: #000000;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -15px;
}

.height-init {
  max-height: initial;
}

.rate {
  font-size: 15px;
  color: #848484;
}

.star {
  color: #ffc500;
}
@media only screen and (min-width: 992px) {
  h1 {
    font-size: 40px;
    padding-top: 0;
  }

  .paddingt {
    padding-top: 100px;
  }

  .tabs {
    width: 100%;
    border-bottom: 0.5px solid #707070;
    opacity: 1;
    justify-content: space-between;
    text-align: left;
    padding-bottom: 14px;
  }

  .text3 {
    color: #707070;
    opacity: 1;
    font-size: 15px;
    position: relative;
    padding: 0;
  }

  .price {
    font-size: 39px;
    margin-right: 28px;
  }

  .price > span {
    font-size: 22px;
  }

  .paypal {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    width: 159px;
    height: 51px;
    margin: 0;
  }

  .btn-card {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    width: 159px;
    height: 51px;
    border-left: none;
    margin: 0;
  }

  .d-flex {
    align-items: center;
  }

  .module-desk {
    width: 100%;
    border-bottom: 0.5px solid #707070;
    /* align-items: center; */
    display: flex;
    justify-content: space-between;
    padding: 0 0;
  }

  .module-desk:nth-last-of-type(1) {
    border-bottom: none;
  }
}

.cursor-pointer {
  cursor: pointer;
}

.blue-font {
  color: #446daf;
  font-weight: 400;
}

.heightForFooter {
  min-height: calc(100vh - 600px);
}
</style>
